import { ISelectOption } from '@northladder/utilities';

import { ITradeInDevicesBrandRaw } from '../types';

/**
 * This formats the raw brand data into the desired structure.
 */
export function formatAllBrands(
  brandsData: ITradeInDevicesBrandRaw[]
): ISelectOption[] {
  return brandsData?.map((brand) => ({
    value: brand._id,
    label: {
      en: brand.name,
      ar: brand.name_ar || brand.name,
    },
    labelStr: brand.name,
  }));
}
